export const formatString = (template = "", values = []) =>
  template.replace(/\[(\d+)\]/g, (match, index) => {
    return values[index] || undefined;
  });
